import React from 'react'
import { useState, useEffect, useMemo } from 'react'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import { submitApplication } from '@ms/shared/services/api/register'
import './style/login.css'
import { Button, Form, Container, Row, Col , Image } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Footer from '@ms/shared/components/frame/footer'
import HeaderTop from '@ms/shared/components/frame/header'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Card } from 'primereact/card'
import { InputMask } from 'primereact/inputmask'
import registerIcon from '../../assets/images/register_icon.png'
import { Calendar } from 'primereact/calendar'
import calendarIcon from '../../assets/images/register_calendar_icon.png'

const Register = () => {
	const { t } = useTranslation()
	const [selectedReligion, setSelectedReligion] = useState()
	const [email, setEmail] = useState('')
	const [titleTH, setTitleTH] = useState('')
	const [titleEN, setTitleEN] = useState('')
	const [firstname, setFirstname] = useState('')
	const [lastname, setLastname] = useState('')
	const [firstnameEn, setFirstnameEn] = useState('')
	const [lastnameEn, setLastnameEn] = useState('')
	const [tel, setTel] = useState('')
	const [cardid, setCardId] = useState('')
	const [date, setDate] = useState(null);

	const religions = useMemo(() => [
        { name: t('auth.register.religions.buddhist'), code: 'พุทธ' },
        { name: t('auth.register.religions.christian'), code: 'คริส' },
    ], [t]);

	const titleOptionTH = useMemo(() => [
		{ id: 'boy', name: t('auth.register.titles.boy') },
		{ id: 'girl', name: t('auth.register.titles.girl') },
		{ id: 'mr', name: t('auth.register.titles.mr') },
		{ id: 'miss', name: t('auth.register.titles.miss') },
		{ id: 'mrs', name: t('auth.register.titles.mrs') },
	], [t]);

	const titleOptionEN = useMemo(() => [
		{ id: 'mr', name: t('auth.register.titlesEn.mr') },
		{ id: 'miss', name: t('auth.register.titlesEn.miss') },
		{ id: 'ms', name: t('auth.register.titlesEn.ms') },
		{ id: 'mrs', name: t('auth.register.titlesEn.mrs') },
	], [t]);

	useEffect(() => {
		// reserved for future option loading
	}, [])

	const elementGroupClassName = 'text-right align-self-center'

	const goLoginPage = async () => {
        setInterval(function () {
            window.location.replace("/login");
        }, 1000);
    };
	
	const activeRegister = async (e) => {
		e.preventDefault();
		
		let payload = {
			email: email,
			name_title: titleTH?.id,
            name_title_en: titleEN?.id,
            first_name: firstname,
            last_name: lastname,
            first_name_en: firstnameEn,
            last_name_en: lastnameEn,
            tel: tel,
            cid: cardid,
            regional: selectedReligion?.code,
            birthdate: date?.toISOString(),
		}
		
		let result = await submitApplication(payload)

		if (result.status >= 200 && result.status <= 250) {
			await Swal.fire({
				icon: 'success',
				text: t('auth.register.successOtp'),
			})
			localStorage.setItem('app_id', result.data.application_id)
			window.location.replace('/verify')
		} else {
			await Swal.fire({
				icon: 'error',
				text: result.data.message,
			})
		}
	}

	return (
		<>
			<HeaderTop activeMenu={'login'}></HeaderTop>
			<Container className='container-size' fluid>
				<Row>
					<h4 className='p-3 text-center text-secondary'>
						<Image width={70} src={registerIcon}/>{t('auth.register.pageTitle')}
					</h4>
				</Row>
				<Row className='justify-content-center'>
					<Col lg={9} md={12}>
						<Row className='my-2 mt-4 text-color-ms'>
							<h5 className='text-left mb-0'>{t('auth.register.emailSectionTitle')}</h5>
							<small>{t('auth.register.emailSectionDesc')}</small>
						</Row>
						<Card className='card-register py-4 px-4'>
							<Form id='register' onSubmit={activeRegister}>
								<Row>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='name'>{t('auth.register.email')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<InputText id='name' value={email} className='mr-3' style={{width:"95%"}} onChange={(e) => setEmail(e.target.value)} required />
									</Col>
								</Row>
							</Form>
						</Card>
					</Col>
				</Row>
				<Row className='justify-content-center'>
					<Col lg={9} md={12}>
						<Row className='my-2 mt-4 text-color-ms'>
							<h5 className='text-left mb-0'>{t('auth.register.personalSectionTitle')}</h5>
							<small>{t('auth.register.personalSectionDesc')}</small>
						</Row>
						<Card className='card-register py-4 px-4'>
							<Form id='register' onSubmit={activeRegister}>
								<Row>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='card_id'>{t('auth.register.citizenId')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<InputMask id='card_id' value={cardid} keyfilter='int' style={{width:"95%"}} onChange={(e) => setCardId(e.target.value)} mask='9999999999999' required />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='title'>{t('auth.register.titleLabel')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<Dropdown id='title' value={titleTH} options={titleOptionTH} optionLabel='name' style={{width:"40%"}} onChange={(e) => setTitleTH(e.target.value)} required />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='name'>{t('auth.register.fullName')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<InputText id='name' value={firstname} className='mr-3' style={{width:"40%"}} onChange={(e) => setFirstname(e.target.value)} required />
										<InputText id='lastname' value={lastname} style={{width:"52%"}} onChange={(e) => setLastname(e.target.value)} required />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='title-en'>{t('auth.register.titleEn')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<Dropdown id='title-en' value={titleEN} options={titleOptionEN} optionLabel='name' style={{width:"40%"}} onChange={(e) => setTitleEN(e.target.value)} required />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='name-en'>{t('auth.register.fullNameEn')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<InputText id='name-en' value={firstnameEn} className='mr-3' style={{width:"40%"}} onChange={(e) => setFirstnameEn(e.target.value)} required />
										<InputText id='lastname-en' value={lastnameEn} style={{width:"52%"}} onChange={(e) => setLastnameEn(e.target.value)} required />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor="buttondisplay">{t('auth.register.birthDate')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<Calendar className="register-calendar" id="buttondisplay" placeholder={t('auth.register.birthDatePlaceholder')} dateFormat='dd/mm/yy'showIcon icon={<Image width={30} style={{color:"white"}} src={calendarIcon} />} style={{width:"40%"}} value={date}  onChange={(e) => setDate(e.target.value)} />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor='tel'>{t('auth.register.phone')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<InputMask value={tel} style={{width:"95%"}} onChange={(e) => setTel(e.target.value)} mask='9999999999' required />
									</Col>
									<Col xs={13} md={3} className={elementGroupClassName}>
										<label htmlFor="religion">{t('auth.register.religion')}</label>
									</Col>
									<Col xs={13} md={8} className='my-3'>
										<Dropdown value={selectedReligion} style={{width:"40%"}} onChange={(e) => setSelectedReligion(e.value)} options={religions} optionLabel="name"/>
									</Col>
								</Row>
							</Form>
						</Card>
						<div className='offset-md-2 col-md-8 offset-lg-3 col-lg-6 my-3'>
							<div className='flex justify-content-center p-4 my-4'>
								<Button type='submit' form='register' className='btn-register-submit px-5 mr-3'>
									{t('auth.register.submit')}
								</Button>
								<Button onClick={goLoginPage} className='btn-register-cancel px-5'>
									{t('auth.register.cancel')}
								</Button>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
			<Footer/>
		</>
	)
}

export default Register
